"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var PenNibSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M11.706757,14.7683795 C11.8346775,15.3056455 11.5028374,15.8448857 10.9655713,15.9728062 C10.8896893,15.9908734 10.811954,16 10.7339508,16 L8.2660492,16 C7.71376445,16 7.2660492,15.5522847 7.2660492,15 C7.2660492,14.9219968 7.27517584,14.8442615 7.29324298,14.7683795 L7.56236951,13.6380481 C6.52078984,12.6857603 6,11.4730776 6,10 C6,8.45870054 6.99775369,5.9196474 8.99326106,2.38284058 C9.21473694,1.85716248 9.80995178,1.89227295 10.0081828,2.38539985 C12.0027276,5.92087229 13,8.45907234 13,10 C13,11.4730776 12.4792102,12.6857603 11.4376305,13.6380481 L11.706757,14.7683795 Z M10.6498827,13 C11.5615188,12.220139 12,11.2432549 12,10 C12,8.895537 11.3352549,7.02868967 10,4.46489566 L10,9 L9,9 L9,4.46489566 C7.66474507,7.02868967 7,8.895537 7,10 C7,11.2432549 7.43848116,12.220139 8.35011732,13 L10.6498827,13 Z M8.2660492,15 L10.7339508,15 L10.4958556,14 L8.50414444,14 L8.2660492,15 Z" })));
};
PenNibSmall.displayName = 'PenNibSmall';
exports.default = PenNibSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PenNibSmall.js.map